export default "__VITE_ASSET__b238c2b3__"